import { InstanceScreen } from 'component/navigation/instance';

export default function SpaceEditScreen() {
    return <InstanceScreen screenKey='edit' />;
}
